import $ from 'jquery';
import { getMetadata } from '~loader/loader-utils';

export const composeMetadataCanvasNavText = () => {
  const metadata = getMetadata();
  const canvasNavInfo = `
    <div class="navbar-canvas-metadata-line">
        ${metadata.projectTypeName} ${metadata.formatName}
    </div>
    <div class="navbar-canvas-metadata-line">
        ${metadata.templatesCategoryName || ''}  ${
    metadata.servizioName
      ? `| <a href="${process.env.ETERNO_URL}/index.php?page=detaildefunto&objectid=${metadata.servizioId}" 
      data-tracking-eterno-open-service
      data-toggle="tooltip"
      data-placement="bottom"
      title="Apri servizio in Eterno"
      class="linkServizio" 
      target="_blank"> ${metadata.servizioName}`
      : ''
  } 
    </div>`;

  $('#navbar-canvas-metadata').html(canvasNavInfo);
};
